import service from "./service"

const icoverCredentialsStatus = async () => {
    return service()
}

export default icoverCredentialsStatus
